import * as React from 'react'
import Icon from 'src/components/Icon/Icon'

interface IResultsCaloriesAndCashProps {
  calories: number
  cash?: number
  showCalories: boolean
}

const ResultsCaloriesAndCash: React.FC<IResultsCaloriesAndCashProps> = ({
  calories,
  cash = 0,
  showCalories = false,
}) => {
  return (
    <div
      className={`ResultsCaloriesAndCash${
        (showCalories && !cash) || (!showCalories && cash > 0)
          ? ' ResultsCaloriesAndCash--single'
          : ''
      }`}
    >
      {showCalories && (
        <div className="ResultsCaloriesAndCash__calories-container">
          <h5 className="ResultsCaloriesAndCash__calories-title">
            Par jour, vous absorbez en moyenne
          </h5>
          <div className="ResultsCaloriesAndCash__calories-details">
            <Icon name="calories" />
            <p className="ResultsCaloriesAndCash__calories-number">{calories} calories</p>
          </div>
        </div>
      )}
      {cash > 0 && (
        <div className="ResultsCaloriesAndCash__cash-container">
          <h5 className="ResultsCaloriesAndCash__cash-title">Par an, vous dépensez en moyenne</h5>
          <div className="ResultsCaloriesAndCash__cash-details">
            <Icon name="money" />
            <p className="ResultsCaloriesAndCash__cash-number">{cash * 52} €</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default ResultsCaloriesAndCash



// WEBPACK FOOTER //
// ./src/components/ResultsComponents/ResultsCaloriesAndCash/ResultsCaloriesAndCash.tsx